<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Crear Producto / Examen</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="submitProduct">
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">SKU (Código único)</label>
                                    <argon-input v-model="product.sku" type="text" placeholder="Ej: LAB-HMG01" />
                                    <small v-if="submitted && v$.product.sku.$error" class="text-danger">SKU requerido y único</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre</label>
                                    <argon-input v-model="product.name" type="text" placeholder="Ej: Hemograma Completo" />
                                    <small v-if="submitted && v$.product.name.$error" class="text-danger">Nombre requerido</small>
                                </div>

                                <div class="col-md-12 mt-3">
                                    <label class="form-control-label">Descripción</label>
                                    <argon-input v-model="product.description" type="textarea" rows="3" placeholder="Descripción detallada del producto o análisis" />
                                    <small v-if="submitted && v$.product.description.$error" class="text-danger">Descripción requerida</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-label mb-1">Unidad de Medida</label>
                                    <ArgonLookup
                                        :options="units"
                                        v-model="unitSelected"
                                        track-by="id"
                                        display-key="name"
                                        placeholder="Seleccione la unidad..."
                                    >
                                        <template #option="{ option }">
                                            <span>
                                                <span class="font-weight-bold">{{ option.code }}</span>
                                                ({{ option.name }})
                                            </span>
                                        </template>
                                    </ArgonLookup>
                                    <small v-if="loadingUnits" class="text-muted">Cargando unidades...</small>
                                    <small v-if="submitted && v$.product.unit.$error" class="text-danger">Unidad requerida.</small>
                                </div>



                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Precio de Costo</label>
                                    <argon-input v-model="product.price" type="number" step="0.01" placeholder="0.00" />
                                    <small v-if="submitted && v$.product.price.$error" class="text-danger">Precio de costo requerido y mayor a 0</small>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Precio de Venta</label>
                                    <argon-input v-model="product.sale_price" type="number" step="0.01" placeholder="0.00" />
                                    <small v-if="submitted && v$.product.sale_price.$error" class="text-danger">Precio de venta requerido y mayor a 0</small>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Estado</label>
                                    <select class="form-control" v-model="product.state">
                                        <option value="">Seleccione un estado</option>
                                        <option :value="1">Activo</option>
                                        <option :value="2">Inactivo</option>
                                    </select>
                                    <small v-if="submitted && v$.product.state.$error" class="text-danger">Estado requerido</small>
                                </div>

                                <div class="col-md-6 mt-3">
                                    <label class="form-control-label">Gravable (Impuesto)</label>
                                    <div class="form-check">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="product.taxable"
                                            id="taxable"
                                        />
                                        <label class="form-check-label" for="taxable">Sí, aplica impuestos</label>
                                    </div>
                                    <div class="form-check mt-2">
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-model="product.is_lab_test"
                                            id="is_lab_test"
                                        />
                                        <label class="form-check-label" for="is_lab_test">Es Examen de Laboratorio (Servicio)</label>
                                    </div>
                                </div>


                                <div class="col-md-12 mt-3 text-center">
                                    <div>
                                        <label class="form-control-label">Foto del producto</label>
                                    </div>
                                    <div class="image-upload-area mx-auto" @click="uploadPhoto()">
                                        <img :src="product.photo_url || fileUpload" alt="Foto producto" class="img-thumbnail" style="max-width:200px; height: auto; display: block;" @error="handleImageError" />
                                        <input type="file" style="display: none !important;" ref="productPhotoFile" accept="image/jpeg, image/png" @change="onFileChange($event)">
                                    </div>
                                    <small class="text-muted d-block mt-1">Haz clic en la imagen para subir una foto.</small>
                                </div>
                            </div>

                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Guardar Producto
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonLookup from "@/components/ArgonLookup.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
import fileUpload from '@/assets/img/uploadfile.jpg';

const companyId = localStorage.getItem('companyId');

export default {
    name: "EditProduct", // 🛑 Renombrado para edición 🛑
    components: { ArgonInput, ArgonButton, ArgonLookup },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        const productId = this.$route.params.id; // Obtener ID de la URL

        return {
            fileUpload,
            submitted: false,
            loading: true, // Para mostrar un cargador al inicio
            loadingCategories: false,
            loadingUnits: false,

            productId: productId, // ID del producto a editar

            // LOOKUP MODELS
            categorySelected: null, // Objeto de Categoría
            unitSelected: null,     // Objeto de Unidad
            categories: [],
            units: [],

            product: {
                id: productId, // Necesario para la llamada PUT
                sku: '',
                name: '',
                description: '',
                unit: null, // 🛑 Usamos unit_id para la BD 🛑
                price: 0.00,
                sale_price: 0.00,
                taxable: true,
                is_lab_test: false,
                state: 1,
                photo_url: null,
                company: parseInt(companyId)
            }
        };
    },
    validations() {
        // ... (Validaciones se mantienen igual) ...
        return {
            product: {
                sku: { required: helpers.withMessage('SKU requerido', required) },
                name: { required: helpers.withMessage('Nombre requerido', required) },
                description: { required: helpers.withMessage('Descripción requerida', required) },
                unit: { required: helpers.withMessage('Unidad requerida', required) }, // Asumo que el campo en data es unit_id
                price: { required, minValue: helpers.withMessage('Debe ser mayor a 0', (value) => value > 0) },
                sale_price: { required, minValue: helpers.withMessage('Debe ser mayor a 0', (value) => value > 0) },
                state: { required: helpers.withMessage('Estado requerido', required) },
            }
        };
    },
    watch:{
        // Mapeo de Lookups: Ahora mapean el objeto seleccionado al ID de la BD
        categorySelected(newVal){
            this.product.category = newVal ? newVal.id : null;
        },
        unitSelected(newVal){
            this.product.unit = newVal ? newVal.id : null; // 🛑 Corregido a unit_id 🛑
        }
    },
    methods: {

        // 🛑 NUEVO: Función para cargar los datos existentes 🛑
        async fetchProductData(config) {
            try {
                const response = await axios.get(`${this.$store.state.apiURL}products/${this.productId}`, config);
                const data = response.data;

                // 1. Asignar todos los datos recibidos a this.product
                this.product = {
                    ...this.product,
                    ...data,
                    // Aseguramos que los booleanos se manejen correctamente si vienen como 1/0
                    taxable: !!data.taxable,
                    is_lab_test: !!data.is_lab_test
                };

                // Mapear Unidad
                if (this.product.unit) {
                    this.unitSelected = this.units.find(u => u.id === this.product.unit);
                }

                // Mapear Categoría
                if (this.product.category) {
                    this.categorySelected = this.categories.find(c => c.id === this.product.category);
                }

            } catch (error) {
                this.handleSessionError(error);
                Swal.fire('Error', 'No se pudieron cargar los datos del producto.', 'error').then(() => {
                    this.$router.push('/products');
                });
            }
        },

        // 🛑 MÉTODOS FETCH: Adaptados para reusarse 🛑
        async fetchUnits(config){
            this.loadingUnits = true;
            // ... (Axios call and mapping logic remains) ...
            try {
                const result = await axios.get(this.$store.state.apiURL + `units?company=${companyId}`, config);
                // Asegurarse de que el mapeo use 'id' y 'value'
                this.units = result.data.map(item => ({ id: item.id, code:item.code, name:item.name, value: item.id }));
            } catch (error) { this.handleSessionError(error); } finally { this.loadingUnits = false; }
        },
        async fetchCategories(config){
            this.loadingCategories = true;
            // ... (Axios call and mapping logic remains) ...
            try {
                const result = await axios.get(this.$store.state.apiURL + `products_category?company=${companyId}`, config);
                this.categories = result.data.map(item => ({ id: item.id, name: item.name, value: item.id }));
            } catch (error) { this.handleSessionError(error); } finally { this.loadingCategories = false; }
        },

        // 🛑 MODIFICADO: submitProduct ahora usa PUT 🛑
        async submitProduct() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) { /* ... */ return; }

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const config = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } };

            // Payload limpio para la API
            const payload = {
                ...this.product,
                taxable: this.product.taxable ? 1 : 0,
                is_lab_test: this.product.is_lab_test ? 1 : 0,
                // Aseguramos que los IDs se envíen como números (si es necesario)
                unit: parseInt(this.product.unit),
                category: parseInt(this.product.category)
            };

            try {
                // 🛑 LLAMADA PUT AL ENDPOINT CON EL ID 🛑
                await axios.put(`${apiURL}products/${this.productId}`, payload, config);

                Swal.fire({
                    title: 'Producto Actualizado',
                    text: 'El ítem fue actualizado correctamente.',
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                }).then(() => {
                    this.$router.push('/products');
                });

            } catch (err) {
                // ... (Manejo de error) ...
            }
        },
        handleSessionError(error) {
            const self = this;
            if (error.response && error.response.status === 401) {
                Swal.fire({
                    title: 'Sesión',
                    text: 'El tiempo de sesión ha vencido, ingresa nuevamente.',
                    icon:'warning',
                    confirmButtonColor:'#bf4f51',
                }).then(function(){
                    localStorage.removeItem('user');
                    localStorage.removeItem('accessToken');
                    self.$router.push('/signin');
                });
            }
        }
    },
    async mounted(){
        const token = localStorage.getItem("accessToken");
        const config = { headers: { 'Authorization': `Bearer ${token}` } };

        this.loading = true; // Activar cargador

        // 1. Carga de datos maestros (debe ir primero)
        await Promise.all([
            this.fetchUnits(config),
            this.fetchCategories(config)
        ]);

        // 2. Carga de datos del producto a editar (después de que los masters estén listos)
        if (this.productId) {
            await this.fetchProductData(config);
        } else {
            Swal.fire('Error', 'ID de producto no proporcionado.', 'error');
            this.$router.push('/products');
        }

        this.loading = false; // Desactivar cargador
    }
};
</script>

<style scoped>
.image-upload-area {
    cursor: pointer;
    border: 2px dashed #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 8px;
    display: inline-block;
}
.image-upload-area:hover {
    border-color: #5e72e4;
}
</style>